"use strict";

class UserProfileCtrl {

    constructor($state, $http, User, $mdToast, $mdDialog, $window) {
        this.$state = $state;
        this.$http = $http;
        this._User = User;
        this.buttonDisabled = false;
        this.formdata = {};
        this.socialAccounts = [];
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$window = $window;
        this.isLoaded = false;
        this.isOpen = false;

        this.fetch();
    }

    fetch() {
        this.isLoaded = false;
        this.$http.get('/profile').then((response) => {
            this.formdata = response.data;
            this.isLoaded = true;
        });
        this.$http.get('/station').then((response) => {
            this.adfs = response.data.is_adfs;
        });
    }

    cancel() {
        this.$state.go('user');
    }

    save($valid) {
        this.isLoaded = false;

        if (!$valid) {
            return;
        }
        this.buttonDisabled = true;

        let modelData = angular.copy(this.formdata);

        this.$http.put('/profile', modelData)
            .then((response) => {
                console.log(response.data);
                if (response.data.shallReload) {
                    location.reload();
                } else {
                    this.fetch();
                }
            })
            .catch((error) => {
                this.fetch();
                if(error.data['email']) {
                    this.emailError = true;
                }
            });
    }

    updatePassword(ev) {
        this.$mdDialog.show(
            {
                controller: 'changePasswordDialog',
                templateUrl: "changePasswordDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: false,
                openFrom: '#change-password',
                closeTo: '#change-password'
            })
    }

}

UserProfileCtrl.$inject = ['$state', '$http', 'User', '$mdToast', '$mdDialog', '$window'];


module.exports = UserProfileCtrl;
